module.exports = __webpack_public_path__ + "img/nywl.77d49fc9.png";